import { FC } from "react";

interface JobPerformanceSectionHeaderProps {
    title: string;
    tooltip: string;
}

export const JobPerformanceSectionHeader: FC<JobPerformanceSectionHeaderProps> = ({ title, tooltip }) => {
    return (
        <div className="jp-section-header">
            <span className="jp-section-header__title">{title}</span>
            <span className="jp-section-header__info" data-tooltip={tooltip}>ⓘ</span>
        </div>
    );
};
